/**
 * Verloren und gestohlen: nach „Unbekannt“ (ADR 0020).
 *
 * Wer einem Artikel einen Status mit dem Kennzeichen `ort_unbekannt` setzt
 * (voreingestellt: verloren, gestohlen), bringt ihn damit an den Ort
 * „Unbekannt“. Er verschwindet aus seinem Packstück und steht im Lager-Baum
 * dort, wo man ihn sucht. Taucht er wieder auf, wird er gescannt und
 * eingebucht -- die Bewegung setzt den Status zurück (`nachBewegung` in
 * `zustand.ts`).
 *
 * Die Verschiebung ist eine **eigene, abgeleitete Buchung** -- sichtbar im Log,
 * so wie der Inhalt eines Packstücks (ADR 0012). Der Server leitet sie beim
 * Eintreffen ab, das Gerät nimmt sie offline vorweg. Beide mit dieser
 * Funktion.
 *
 * Nur für eine **eigene** Statusänderung. Eine abgeleitete -- der Inhalt einer
 * verlorenen Kiste -- bleibt in der Kiste: Findet man die Kiste, ist alles
 * zusammen wieder da (so vom Nutzer entschieden).
 */
/**
 * Die Verschiebung nach „Unbekannt“ zu einer Statusänderung -- oder `null`,
 * wenn keine nötig ist.
 *
 * Sie liegt **eine Millisekunde vor** der Statusänderung. Die Ableitung
 * sortiert nach `erfasst_am`: Käme die Bewegung danach, setzte sie den eben
 * gesetzten Status gleich wieder zurück (`nachBewegung`). So steht am Ende
 * beides: Ort „Unbekannt“, Status „verloren“.
 *
 * `schonDort`: Liegt der Artikel schon in „Unbekannt“, braucht es nichts.
 */
export function unbekanntBuchung(ausloeserin, unbekannt_lagerort_id, id, regeln, schonDort = false) {
    if (ausloeserin.art !== "statusaenderung" || ausloeserin.abgeleitet_von !== null)
        return null;
    if (ausloeserin.status === null || !regeln.ortUnbekannt.has(ausloeserin.status))
        return null;
    if (schonDort)
        return null;
    return {
        ...ausloeserin,
        id,
        art: "umlagerung",
        status: null,
        ziel_lagerort_id: unbekannt_lagerort_id,
        einsatzstelle_id: null,
        menge: null,
        menge_absolut: null,
        erfasst_am: new Date(Date.parse(ausloeserin.erfasst_am) - 1).toISOString(),
        abgeleitet_von: ausloeserin.id,
    };
}
//# sourceMappingURL=unbekannt.js.map